module.exports = __webpack_public_path__ + "static/FjallaOne-4fa3683005fa20dd058f47b9cfd411df.ttf";